//GA tracking.
function finder_event_track(track_event, track_label) {
    if (typeof ga != "undefined") {
      ga('send', 'event', 'RoutineFinder', track_event, track_label);
      
    }
    console.log([track_event, track_label]);
}
function finder_final_routine_track(track_event, track_label,callback=''){
    if (typeof ga != "undefined") {
      if(callback==''){
      	ga('send', 'event', 'RoutineFinderFinal', track_event, track_label);
      }else{
        ga('send', 'event', 'RoutineFinderFinal', track_event, track_label, { 'hitCallback': callback } );
      }
    }else{
      if(callback!=''){ callback(); }
    }
  
  	console.log([track_event, track_label]);
}

var host = window.location.host;
var store = 'uk';
if (host.indexOf("eu") != -1) var store = 'eu';
else if (host.indexOf("us") != -1) var store = 'us';
var routine_finder_app = {
    name: 'Routine Finder',
    settings: {
        root_url: '/',
        share_url: 'https://zelens.com/pages/routine-finder-app#',
        post_url: 'https://zelens-routine-finder.linko.dev/routine-email',
        store_location: store,
        result_page_url: '/pages/results',
        test_mode: false
    },
    sizes: []
};
var error_finish_msg = "";

var routine_finder_app_loader = {};
$(document).ready(function() {
    define_rfapp(routine_finder_app);
    setup_rfapp(routine_finder_app);

    function setup_rfapp(app) {

        /* start button */
        /*
        $('.rf-button-launch').click(function() {
            app.event_start('blank');
        });
        */

        $('.sz-button-continue').click(function() {
            app.event_steps();
        });

        $('.rf-button-finish').click(function() {
            app.event_finish();
        });

        // Desktop button step back
        $('.sz-button-step-back').click(function() {
            app.event_button_step_back($(this));
        });

        $('.rf-button-exit-confirm').click(function() {
            app.event_confirm_exit(true)
        });
        $('.rf-input').keyup(function() {
            app.event_input_name($(this));
        });
        $('.rf-email').keyup(function() {
            app.event_input_email($(this));
        });
        app.setup_routine_finder();
        app.setup_options();
        if ($(".page-maker-block").length > 0) app.event_start('blank');
    }

    function define_rfapp(app) {
        //event : something has happened
        //action : do something
        //get : give me data
        //set : set some data

        app.data = {};
        app.data.missclicks = 0;
        app.data.doubleclicks = 0;
        app.data.engine = '';

        // ------------------------------------------------------------------
        /* 1. __EVENT */
        // ------------------------------------------------------------------

        app.event_start = function(type) {
            if (window.location.hash) {
                app.action_load_from_url();
            } else {
                finder_event_track('start', type);
                //do start up
                this.action_app_show();
                this.action_init_finder_data();
                if (type == 'blank') {
                    app.action_wipe_finder();
                    app.action_show_panel_step('detail');
                }
            }
        }
        app.event_finish = function() {
            //can only finish if ready
            if (this.get_is_rountine_finder_complete() || (this.settings.test_mode)) {
                var result_page = app.get_result_page_url();
                let parts = this.data.finder_parts;
                if (parts['receive'] == 'receive_no') {
                  	$(".modal-add-cart,.modal-loader").show();
                    finder_event_track('finish', 'Completed');
                    app.action_store_routine_finder();
                    window.location.href = result_page;
                } 
                else if(parts['receive'] == 'receive_yes' && $(".rf-email").val() != ""){
                  	$(".modal-add-cart,.modal-loader").show();
                  	finder_event_track('finish', 'Completed');
                    app.action_store_routine_finder();
                    var share_url = app.get_share_url();
                    var post_url = app.get_post_url();
                    var data = app.get_finder_uri("post-data");
                    $.ajax({
                        type: "POST",
                        url: post_url,
                        data: data,
                        dataType: "JSON",
                        success: function(data, status, xhr) {
                          console.log('status: ' + status + ', data: ' + data);
                          console.log(data);
                          //if(status == 'success') {
                          if(data.success == 'success'){
                            //console.log('redirect paused for debugging..');
							window.location.href = result_page;
                          }else{
                          	$(".modal-add-cart,.modal-loader").hide();
                          }
                        }

                    });
                    console.log(share_url);
                }
            } else {
                this.data.missclicks = this.data.missclicks + 1;
                if (this.data.missclicks == 3) {
                    alert("* Select all the options to be able to see your results");
                    this.data.missclicks = 0;
                }
            }
        }
        app.event_steps = function() {
            var current_step = $(".sz-button-continue").data('step');
            var invalid = 0;
            var current = '';

            // error message
            $(".js-error-msg").addClass("hide");
            if ($(".step-panel").hasClass("active") && $(".sz-button-continue").hasClass("disable")) {
                $(".js-error-msg").removeClass("hide");
                $(".step-panel.active").addClass("error");
                if ($(".step-panel.active").hasClass("panel-detail")) {
                    var placeholder = $(".step-panel.active input").attr("placeholder");
                    if (placeholder.indexOf("*") == -1)
                        $(".step-panel.active input").attr("placeholder", placeholder + '*');
                }
            }

            if ($(".sz-button-continue").hasClass("disable")) return false;

            if ($(".sz-button-continue").data('next-step')) {
                var current = $(".sz-button-continue").attr('data-next-step');
            }
            let parts = this.data.finder_parts;

            if (current == 'detail') {
                app.action_show_panel_step('age');
                app.action_update_back_step('detail');
                if (parts['age'] == undefined) app.action_continue_button(false);
                if (parts['age'] != undefined) $(".sz-button-continue").attr('data-next-step', "age");
                return true;
            }

            if (current == 'age') {
                app.action_show_panel_step('gender');
                app.action_update_back_step('age');
                if (parts['gender'] == undefined) app.action_continue_button(false);
                if (parts['gender'] != undefined) $(".sz-button-continue").attr('data-next-step', "gender");
                var save_id = $(".step-panel input[name='age']:checked").data("id");
                var save_tag = $(".step-panel input[name='age']:checked").data("tag");
                app.action_swap_age(save_id, save_tag);
                return true;
            }

            if (current == 'gender') {
                app.action_show_panel_step('client');
                app.action_update_back_step('gender');
                if (parts['client'] == undefined) app.action_continue_button(false);
                if (parts['client'] != undefined) $(".sz-button-continue").attr('data-next-step', "client");
                var save_id = $(".step-panel input[name='gender']:checked").data("id");
                var save_tag = $(".step-panel input[name='gender']:checked").data("tag");
                app.action_swap_gender(save_id, save_tag);
                return true;
            }
            if (current == 'client') {
                app.action_show_panel_step('feeding');
                app.action_update_back_step('gender');

                if(parts['gender'] != undefined && parts['gender'] == "male|rfa_gender"){
                    var value = 'hide_feeding';
                    $("input[name=feeding][value=" + value + "]").trigger("click");
                    $('.sz-button-continue').trigger("click");
                }else if(parts['feeding'] != undefined && parts['feeding'].indexOf("hide_feeding") != -1){
                    var value = 'hide_feeding';
                    $("input[name=feeding][value=" + value + "]").prop("checked",false);
                    app.action_continue_button(false);
                }

                if (parts['feeding'] == undefined) app.action_continue_button(false);
                if (parts['feeding'] != undefined) $(".sz-button-continue").attr('data-next-step', "feeding");
                var save_id = $(".step-panel input[name='client']:checked").data("id");
                var save_tag = $(".step-panel input[name='client']:checked").data("tag");
                app.action_swap_client(save_id, save_tag);
                return true;
            }
            if (current == 'feeding') {
                app.action_show_panel_step('skin-type');
                app.action_update_back_step('feeding');
                if (parts['skin-type'] == undefined) app.action_continue_button(false);
                if (parts['skin-type'] != undefined) $(".sz-button-continue").attr('data-next-step', "skin-type");
                var save_id = $(".step-panel input[name='feeding']:checked").data("id");
                var save_tag = $(".step-panel input[name='feeding']:checked").data("tag");
                app.action_swap_feeding(save_id, save_tag);
                return true;
            }
            if (current == 'skin-type') {
                app.action_show_panel_step('skin-concern');
                app.action_update_back_step('skin-type');
                if (parts['skin-concern'] == undefined) app.action_continue_button(false);
                if (parts['skin-concern'] != undefined) $(".sz-button-continue").attr('data-next-step', "skin-concern");
                var save_id = $(".step-panel input[name='skin-type']:checked").data("id");
                var save_tag = $(".step-panel input[name='skin-type']:checked").data("tag");
                app.action_swap_skin_type(save_id, save_tag);
                return true;
            }
            if (current == 'skin-concern') {
                app.action_show_panel_step('skin-enemy');
                app.action_update_back_step('skin-concern');
                if (parts['skin-enemy'] == undefined) app.action_continue_button(false);
                if (parts['skin-enemy'] != undefined) $(".sz-button-continue").attr('data-next-step', "skin-enemy");
                var save_id = $(".step-panel input[name='skin-concern']:checked").data("id");
                var save_tag = $(".step-panel input[name='skin-concern']:checked").data("tag");
                app.action_swap_skin_concern(save_id, save_tag);
                return true;
            }
            if (current == 'skin-enemy') {
                app.action_show_panel_step('eye-concern');
                app.action_update_back_step('skin-enemy');
                if (parts['eye-concern'] == undefined || parts['eye-concern'] == '') app.action_continue_button(false);
                if (parts['eye-concern'] != undefined) $(".sz-button-continue").attr('data-next-step', "eye-concern");
                var save_id = $(".step-panel input[name='skin-enemy']:checked").data("id");
                var save_tag = $(".step-panel input[name='skin-enemy']:checked").data("tag");
                app.action_swap_skin_enemy(save_id, save_tag);
                return true;
            }
            if (current == 'eye-concern') {
                app.action_show_panel_step('lip-concern');
                app.action_update_back_step('eye-concern');
                if (parts['lip-concern'] == undefined || parts['lip-concern'] == '') app.action_continue_button(false);
                if (parts['lip-concern'] != undefined) $(".sz-button-continue").attr('data-next-step', "lip-concern");
                var save_id = '';
                var save_tag = '';
                app.action_swap_eye_concern(save_id, save_tag);
                return true;
            }
            if (current == 'lip-concern') {
                app.action_show_panel_step('receive');
                app.action_update_back_step('lip-concern');
                if (parts['receive'] == undefined) app.action_continue_button(false, 'btn-update');
                if (parts['receive'] != undefined) $(".sz-button-continue").attr('data-next-step', "result-page");
                var save_id = '';
                var save_tag = '';
                app.action_swap_lip_concern(save_id, save_tag);
              	if(parts['receive'] != undefined && parts['receive'] == 'receive_yes' && $(".rf-email").val() == "") app.action_continue_button(false);
                return true;
            }


        }
        app.event_button_step_back = function(e) {
            var target = e.attr("data-step-back");
            let parts = this.data.finder_parts;
            if(parts['gender'] != undefined && parts['gender'] == "male|rfa_gender" && target == "feeding"){
                target = 'client';
            }

            $(".js-error-msg").addClass("hide");
            var pre = $(".panel-" + target).attr("data-step-pre");
            var next = $(".panel-" + target).attr("data-step-next");
            app.action_show_panel_step(target);
            app.action_continue_button(true);

            if (pre != '') {
                e.attr("data-step-back", pre);
            }
            if (next != '') {
                $(".sz-button-continue").attr("data-next-step", next);
            }


        }
        app.event_confirm_exit = function(is_confirmed) {
            this.action_app_hide();
            if (is_confirmed) {
                if (this.data.storage_type != 'shared') {
                    this.action_store_dress(); //save our bracelet
                }
                this.action_app_hide();
                //bead_event_track('close','app closed');
            }
        }
        app.event_input_name = function(ev) {
            if ($(".rf-input").val().length === 0) {
                $(".sz-button-continue").attr('data-next-step', "");
                app.action_continue_button(false);
            } else {
                app.action_continue_button(true);
                $(".sz-button-continue").attr('data-next-step', "detail");

                var name_id = $("input[name='name'].rf-input").val();
                let detail = this.sprites['detail'];
                this.data.finder_parts['detail'] = name_id;
                app.action_check_finder_complete();

            }
        }
        app.event_input_email = function(ev) {
            var email = $(".rf-email").val();
            var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

            $(".valid-icon").addClass("hide");
            if ($(".rf-email").val().length === 0 || !filter.test(email)) {
                $(".sz-button-continue").attr('data-next-step', "");
                app.action_continue_button(false);
            } else {
                $(".valid-icon").removeClass("hide");
                app.action_continue_button(false);

                let val = jQuery("input[name='receive']:checked").val();
                if (val && val.indexOf("yes") != -1) {
                    app.action_continue_button(true);
                    $(".sz-button-continue").attr('data-next-step', "detail");

                    var email_id = $("input[name='email'].rf-email").val();
                    let detail = this.sprites['receive'];
                    this.data.finder_parts['receive_email'] = email_id;
                    app.action_check_finder_complete();
                }
            }
        }

        // ------------------------------------------------------------------
        /* 2. __ACTIONS */
        // ------------------------------------------------------------------


        app.action_init_finder_data = function() {
            this.data.finder_parts = [];
        }

        app.action_app_show = function() {
            $('body').addClass('show-app');
        }

        app.action_show_panel_step = function(action, button) {
            if (action == "detail") {
                app.action_hide_first_step_button_back(true);
            } else {
                app.action_hide_first_step_button_back(false);
            }

            if (action == "receive") {
                $(".sz-button-continue").addClass("hide");
                $(".rf-button-finish").removeClass("hide");

              	//track all final data 
              	app.track_final_answers();
            } else {
                $(".sz-button-continue").removeClass("hide");
                $(".rf-button-finish").addClass("hide");
            }

            let all_panels = ['.panel-detail', '.panel-age', '.panel-gender', '.panel-client', '.panel-feeding', '.panel-skin-type', '.panel-skin-concern', '.panel-skin-enemy', '.panel-eye-concern', '.panel-lip-concern', '.panel-receive'];
            $.each(all_panels, function(index, value) {
                if (value.includes(action)) {
                    $(value).css("display", "block");
                    $(value).addClass("active");
                } else {
                    $(value).hide();
                    $(value).removeClass("active");
                }
            });
        }
        app.action_continue_button = function(is_confirmed) {
            if (is_confirmed) {
                $(".sz-button-continue").removeClass("disable");
                $('.rf-button-finish').removeClass('disable');
            } else {
                $(".sz-button-continue").addClass("disable");
                $('.rf-button-finish').addClass('disable');
            }
        }

        app.action_swap_age = function(id, tag) {
            //console.log(id + "=====================" + tag);
            let age = this.sprites['age'];
            this.data.finder_parts['age'] = id + "|" + tag;
            app.action_check_finder_complete();
        }
        app.action_swap_gender = function(id, tag) {
            if(id == "male"){
                app.action_update_step(10);
            }else{
                app.action_update_step(11);
            }   
            let gender = this.sprites['gender'];
            this.data.finder_parts['gender'] = id + "|" + tag;
            app.action_check_finder_complete();
        }
        app.action_swap_client = function(id, tag) {
            let client = this.sprites['client'];
            this.data.finder_parts['client'] = id + "|" + tag;
            app.action_check_finder_complete();
        }
        app.action_swap_feeding = function(id, tag) {
            let feeding = this.sprites['feeding'];
            this.data.finder_parts['feeding'] = id + "|" + tag;
            app.action_check_finder_complete();
        }
        app.action_swap_skin_type = function(id, tag) {
            let skin_type = this.sprites['skin-type'];
            let tag_val = app.action_result_tags('skin-type', tag);
            this.data.finder_parts['skin-type'] = id + "|" + tag_val;
            app.action_check_finder_complete();
        }
        app.action_swap_skin_concern = function(id, tag) {
            let skin_concern = this.sprites['skin-concern'];
            let tag_val = app.action_result_tags('skin-concern', tag, id);
            this.data.finder_parts['skin-concern'] = id + "|" + tag_val;
            app.action_check_finder_complete();
        }
        app.action_swap_skin_enemy = function(id, tag) {
            let skin_enemy = this.sprites['skin-enemy'];
            let tag_val = app.action_result_tags('skin-enemy', tag);
            this.data.finder_parts['skin-enemy'] = id + "|" + tag_val;
            app.action_check_finder_complete();
        }
        app.action_swap_eye_concern = function(id, tag) {
            let eye_concern = this.sprites['eye-concern'];
            //this.data.finder_parts['eye-concern'] = id + "|" + tag;
            app.store_multi_selected_value('eye-concern');
            app.action_check_finder_complete();
        }
        app.action_swap_lip_concern = function(id, tag) {
            let lip_concern = this.sprites['lip-concern'];
            // this.data.finder_parts['lip-concern'] = id + "|" + tag;
            app.store_multi_selected_value('lip-concern')
            app.action_check_finder_complete();
        }
        app.action_swap_receive = function(id) {
            let receive = this.sprites['receive'];
            let val = jQuery("input[name='receive']:checked").val();
            if (val.indexOf("yes") != -1) {
                var email = $(".rf-email").val();
                var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                if ($(".rf-email").val().length === 0 || !filter.test(email)) {
                    app.action_continue_button(false);

                    this.data.finder_parts['receive'] = id;
                    return false;
                }
            }
            this.data.finder_parts['receive'] = id;
            app.action_check_finder_complete();
        }
        app.action_update_back_step = function(step) {
            if (step) {
                $(".sz-button-step-back").attr("data-step-back", step);
            }
        }
        app.action_hide_first_step_button_back = function(is_confirmed) {
            if (is_confirmed) {
                $(".sz-button-step-back").addClass("hide");
            } else {
                $(".sz-button-step-back").removeClass("hide");
            }
        };
        app.action_check_finder_complete = function() {
            $('.rf-button-finish').addClass('disable');
            if (this.get_is_rountine_finder_complete()) {
                $('.rf-button-finish').removeClass('disable');
            }
        }
        app.action_app_hide = function() {
            window.location.href = this.settings.root_url;
        }

        app.action_store_routine_finder = function() {
            var store_name = app.get_location_url();
            var steps = app.rountine_finder_store_array();
            for (var key in steps) {
                if (this.data.finder_parts[key] != undefined) {
                    var store_val = store + "_" + steps[key];
                    localStorage.setItem(store_val, JSON.stringify(this.data.finder_parts[key]));
                }
            }
            localStorage.finder_stored = 1;
        }
        app.action_wipe_finder = function() {
            var store_name = app.get_location_url();
            var steps = app.rountine_finder_store_array();
            for (var key in steps) {
                var store_val = store + "_" + steps[key];
                localStorage.removeItem(store_val);
            }
            localStorage.removeItem('finder_stored');
        }
        app.action_result_tags = function(action, tag, id) {
            let val = '';
            let parts = this.data.finder_parts;
            if (action == 'skin-type') {
                if (tag.indexOf("normal") == -1) val = "rfa_am," + tag + '#';

                if (parts['age'] != undefined) {
                    var res = parts['age'].split("|");
                    if (res[1] != '') {

                        if (tag.indexOf("dry") != -1 || tag.indexOf("oily") != -1 || tag.indexOf("combination") != -1) {
                            if (res[1].indexOf("under_30") != -1) {
                                val += "rfa_pm," + res[1] + "," + tag + '#';;
                            } else {
                                val += "rfa_pm,rfa_age_over_30," + tag + '#';
                            }
                        }

                    }
                }
                if (tag.indexOf("normal") != -1) {
                    if (res[1].indexOf("under_30") != -1 || res[1].indexOf("under_35") != -1 || res[1].indexOf("over_30") != -1) {
                        val += "rfa_am,rfa_age_under_35," + tag + '#';
                        val += "rfa_pm,rfa_age_under_35," + tag + '#';
                    } else {
                        val += "rfa_am,rfa_age_over_35," + tag + '#';
                        val += "rfa_pm,rfa_age_over_35," + tag + '#';
                    }
                }
                if (tag.indexOf("sensitive") != -1) {
                    val += "rfa_pm," + tag + '#';
                }
                val += tag;
                return val;
            }
            if (action == 'skin-enemy') {
                if (parts['age'] != undefined) {
                    var res = parts['age'].split("|");
                    if (res[1] != '' && res[1].indexOf("over_45") != -1 && ((tag.indexOf("air") != -1) || tag.indexOf("heat") != -1 || tag.indexOf("outdoor_work") != -1 || tag.indexOf("polluted") != -1)) {
                        val = res[1] + "," + tag;
                    } else {
                        val = tag;
                    }
                }
                return val;
            }
            if (action == 'skin-concern') {
                val = 'exfoliate,' + tag + '#';
                if ((tag.indexOf("dullness") == -1) && (tag.indexOf("dryness") == -1)) {

                    val += 'serum,' + tag + '#';
                }

                if ((id.indexOf("wrinkles") != -1) || (id.indexOf("texture") != -1)) {
                    var find = '';
                    if (parts['feeding'] != undefined && parts['feeding'].indexOf("yes") != -1) {
                        var feeding = parts['feeding'].split("|");
                        val += 'power,' + feeding[1] + "," + tag + '#';
                        var find = 'yes';
                    } else if (parts['age'] != undefined && parts['age'].indexOf("under_30") != -1) {
                        var age = parts['age'].split("|");
                        val += 'power,' + age[1] + "," + tag + '#';
                        var find = 'yes';
                    } else {
                        val += 'power,' + tag + '#';
                    }
                } else if ((id.indexOf("dullness") != -1) || (id.indexOf("dryness") != -1)) {
                    if (parts['age'] != undefined) {
                        var res = parts['age'].split("|");
                        if (res[1].indexOf("under_30") != -1 || res[1].indexOf("under_35") != -1) {
                            val += "serum,rfa_age_under_35," + tag + '#';
                        } else {
                            val += "serum,rfa_age_over_35," + tag + '#';
                        }
                    }
                    val += 'power,' + tag + '#';
                } else {
                    val += 'power,' + tag + '#';
                }

                val += 'treat,' + tag + '#';

                return val;
            }
        }

        app.action_update_step = function(totalStepCount) {
            var counter = 1;
            $('.step-panel.js-live').each(function(index, value) {
                   // if(index == 10)return true;                                   
                    if(totalStepCount == 10){
                        if(index == 4) {
                            return true;
                        }
                        console.log(counter);
                        $(this).find(".step-title h5").html('STEP '+ counter +' OF '+ totalStepCount);
                    }
                    
                    if(totalStepCount == 11){
                        $(this).find(".step-title h5").html('STEP '+ counter +' OF '+ totalStepCount);
                    }
                    counter++;
            });    
        }

        app.action_load_from_url = function() {
            var parts = app.get_uri_data();
            var last_step = '';
            if (parts) {
                var steps = app.rountine_finder_store_array();
                for (var key in steps) {
                    if (parts[key] != undefined || parts[key] != null) {
                        var test = parts[key];

                        if (key == 'eye-concern' || key == 'lip-concern') {
                            var data = parts[key];
                            if (data.indexOf("|") != -1) {
                                var valArray = data.split('|');
                                if (valArray[0] != '') {
                                    test = valArray[0];
                                    $(".step-panel input[value='" + test + "']").prop('checked', true);
                                }
                            } else {

                                $(".step-panel input[value='" + data + "']").prop('checked', true);
                            }
                        }
                        if (key != 'detail' && key != 'result') {
                            let type = $(".step-panel input[value='" + test + "']").data('type');
                            let id = $(".step-panel input[value='" + test + "']").data('id');
                            let tag = $(".step-panel input[value='" + test + "']").data('tag');
                            app.event_option_click(type, id, tag);

                        }
                        if (key == 'detail') app.data.finder_parts['detail'] = parts[key];
                        if (key == 'result') app.data.finder_parts['receive'] = parts[key];
                    }
                }
                if (this.get_is_rountine_finder_complete() || (this.settings.test_mode)) {
                    finder_event_track('share', 'Completed');
                    app.action_store_routine_finder();
                    var result_age = app.get_result_page_url();
                    window.location.href = result_age;
                }

            }
        };

        // ------------------------------------------------------------------
        /* 3. SETUP */
        // ------------------------------------------------------------------
        app.setup_routine_finder = function() {
            this.data.isCached = false;
            this.data.engine = '';
            //internal record of finder state
            this.data.finder_parts = [];
            //pixi containers array.
            this.containers = [];
            this.sprites = [];
        }

        app.setup_options = function() {
            this.setup_tab_options();
        }

        app.setup_tab_options = function() {
            $('.option-button').each(function(index, value) {
                $(this).on("click", function() {
                    let type = $(this).data('type');
                    let id = $(this).data('id');
                    let val = $(this).val();
                    let tag = $(this).data('tag');
                    if (val != '' || id != '') {
                        $(".step-panel").removeClass("active error");
                        $(".js-error-msg").addClass("hide");
                    }
                    $(".sz-button-continue").attr('data-next-step', type);
                    app.event_option_click(type, id, tag);
                });
            });
        }

        app.event_option_click = function(type, id, tag, action) {
            // console.log(type + "==============" + id);
            let label = type + ' - ' + id;
            //finder_event_track('click', label);
            finder_event_track(type, id);
          
            var options = ["age", "gender", "client", "feeding", "skin-type", "skin-concern", "skin-enemy", "eye-concern", "lip-concern", "receive"];
            if (jQuery.inArray(type, options) !== -1) {
                app.selected_dress_opt(type, id);
                app.action_continue_button(true);
            }
            if (action == 'restore') {

            } else {
                if (type == 'age') app.action_swap_age(id, tag);
                if (type == 'gender') app.action_swap_gender(id, tag);
                if (type == 'client') app.action_swap_client(id, tag);
                if (type == 'feeding') app.action_swap_feeding(id, tag);
                if (type == 'skin-type') app.action_swap_skin_type(id, tag);
                if (type == 'skin-concern') app.action_swap_skin_concern(id, tag);
                if (type == 'skin-enemy') app.action_swap_skin_enemy(id, tag);
                if (type == 'eye-concern') app.action_swap_eye_concern(id, tag);
                if (type == 'lip-concern') app.action_swap_lip_concern(id, tag);
                if (type == 'receive') app.action_swap_receive(id, tag);

                //if(type != 'size') app.action_update_canvas_layer(type,id);       
            }
        }

        // ------------------------------------------------------------------
        /* 4. GET */
        // ------------------------------------------------------------------

        app.get_is_rountine_finder_complete = function() {
            let parts = this.data.finder_parts;
            if (!('detail' in parts)) {
                return false;
            }
            if (!('age' in parts)) {
                return false;
            }
            if (!('gender' in parts)) {
                return false;
            }
            if (!('client' in parts)) {
                return false;
            }
            if (!('feeding' in parts)) {
                return false;
            }
            if (!('skin-type' in parts)) {
                return false;
            }
            if (!('skin-concern' in parts)) {
                return false;
            }
            if (!('skin-enemy' in parts)) {
                return false;
            }
            if (!('eye-concern' in parts)) {
                return false;
            }
            if (!('lip-concern' in parts)) {
                return false;
            }
            if (!('receive' in parts)) {
                return false;
            }
            /*            if (parts['necklines'] == 'zz' || parts['sleeves'] == 'zz' || parts['lengths'] == 'zz' || parts['prints'] == 'zz' || parts['sizes'] == 'zz') {
                            return false;
                        }
            */
            //ELSE finder is complete.
            return true;
        }
        app.get_result_page_url = function() {
            return this.settings.result_page_url;
        }
        app.get_location_url = function() {
            return this.settings.store_location;
        }


        app.get_share_url = function() {
            return this.settings.share_url + this.get_finder_uri();
        }
        app.get_post_url = function() {
            return this.settings.post_url;
        }

        app.store_multi_selected_value = function(step) {
            var selected_opt = '';
            cls = '.js-lip-panel';
            if (step == 'eye-concern') {
                cls = '.js-eye-panel'
            }
            $(cls + ' .check-radio input[type="checkbox"]').each(function(index) {
                if ($(this).prop("checked") == true) {
                    var id = $(this).data("id");
                    var tag = $(this).data("tag");
                    selected_opt = selected_opt + id + "|" + tag + ',';
                } else if ($(this).prop("checked") == false) {}
            });
            selected_opt = selected_opt.replace(/,\s*$/, "");
            if (selected_opt != '') {
                this.data.finder_parts[step] = selected_opt;
            } else {
                this.data.finder_parts[step] = '';
                app.action_continue_button(false);
            }
        }

        app.show_final_button = function(state){
          if(state){
          	$('.rf-button-finish').css('visibility','visible');
            $('.rf-button-finish').prop('disabled', false);
            $('.rf-button-finish').removeClass('js-disabled');
          }else{
          	$('.rf-button-finish').css('visibility','hidden');
            $('.rf-button-finish').prop('disabled', false);
            $('.rf-button-finish').addClass('js-disabled');
          }
        };
      	
      	app.track_answers_fallback = function(){
          if( $('.rf-button-finish').hasClass('js-disabled') ){
      		app.show_final_button(true);
            var callback = function(){ console.log('fallback'); };
            finder_final_routine_track('data_send_timeout',1,callback);
          }
      	};
      
        app.track_final_answers = function(){
          	app.show_final_button(false);
          
          
          	let age = this.get_short_code(this.data.finder_parts['age']);
            let gender = this.get_short_code(this.data.finder_parts['gender']);
            let client = this.get_short_code(this.data.finder_parts['client']);
            let feeding = this.get_short_code(this.data.finder_parts['feeding']);
            let skin_type = this.get_short_code(this.data.finder_parts['skin-type']);
            let skin_concern = this.get_short_code(this.data.finder_parts['skin-concern']);
            let skin_enemy = this.get_short_code(this.data.finder_parts['skin-enemy']);
            let eye_concern = this.get_short_code(this.data.finder_parts['eye-concern']);
            let lip_concern = this.get_short_code(this.data.finder_parts['lip-concern']);
            let eye_concern_multiple = this.get_short_code_multiple_value(this.data.finder_parts['eye-concern']);
            let lip_concern_multiple = this.get_short_code_multiple_value(this.data.finder_parts['lip-concern']);
          
          	
          
          	var callback = function(){
              app.data.callback_counter += -1;
              console.log( app.data.callback_counter );
              
              if(app.data.callback_counter == 0){
                console.log('Finished Tracking Upload');
                setTimeout(function(){ app.show_final_button(true); }, 500 );
              }
            }
            //fallback!
            setTimeout(function(){ app.track_answers_fallback(); }, 5000 );
            
          	app.data.callback_counter = 12;
          	//must be 12 of these
          	finder_final_routine_track('all_data',[age,gender,client,feeding,skin_type,skin_concern,skin_enemy,eye_concern,lip_concern,eye_concern_multiple,lip_concern_multiple].join(','), callback);
          
            finder_final_routine_track('age',age, callback);
            finder_final_routine_track('gender',gender, callback);
            finder_final_routine_track('client',client, callback);
            finder_final_routine_track('feeding',feeding, callback);
            finder_final_routine_track('skin_type',skin_type, callback);
            finder_final_routine_track('skin_concern',skin_concern, callback);
            finder_final_routine_track('skin_enemy',skin_enemy, callback);
            finder_final_routine_track('eye_concern',eye_concern, callback);
            finder_final_routine_track('lip_concern',lip_concern, callback);
            finder_final_routine_track('eye_concern_multiple',eye_concern_multiple, callback);
            finder_final_routine_track('lip_concern_multiple',lip_concern_multiple, callback);
        }
        
        app.get_finder_uri = function(action) {
            let detail = this.get_short_code(this.data.finder_parts['detail']);
            let age = this.get_short_code(this.data.finder_parts['age']);
            let gender = this.get_short_code(this.data.finder_parts['gender']);
            let client = this.get_short_code(this.data.finder_parts['client']);
            let feeding = this.get_short_code(this.data.finder_parts['feeding']);
            let skin_type = this.get_short_code(this.data.finder_parts['skin-type']);
            let skin_concern = this.get_short_code(this.data.finder_parts['skin-concern']);
            let skin_enemy = this.get_short_code(this.data.finder_parts['skin-enemy']);
            let eye_concern = this.get_short_code(this.data.finder_parts['eye-concern']);
            let lip_concern = this.get_short_code(this.data.finder_parts['lip-concern']);
            let eye_concern_multiple = this.get_short_code_multiple_value(this.data.finder_parts['eye-concern']);
            let lip_concern_multiple = this.get_short_code_multiple_value(this.data.finder_parts['lip-concern']);
            let result = "yes";
            let uri = detail + "&" + age + "&" + gender + "&" + client + "&" + feeding + "&" + skin_type + "&" + skin_concern + "&" + skin_enemy + "&" + eye_concern + "&" + lip_concern + "&" + result;

          	
          
            if (action == 'post-data') {
              	//let email = this.data.finder_parts['receive_email']; //ADDED THIS
              	let email = $(".rf-email").val(); //better than above?
                let share_url = this.settings.share_url + uri;
                return {
                    FNAME: detail,
                    EMAIL: email,
                    ROUTINE: share_url,
                    FINDER1: age,
                    FINDER2: gender,
                    FINDER3: client,
                    FINDER4: feeding,
                    FINDER6: skin_type,
                    FINDER7: skin_concern,
                    FINDER8: skin_enemy,
                    FINDER9: eye_concern_multiple,
                    FINDER10: lip_concern_multiple
                }
            }

            return uri;
        }

        app.get_short_code = function(target) {
            if (target != '') {
                var val = target;
                if (target.indexOf("|") != -1) {
                    var valArray = target.split('|');
                    if (valArray[0] != '') val = valArray[0];
                }
            }
            console.log( 'Shortcode for '+target+' = '+val );
            return val;
        }
        app.get_short_code_multiple_value = function(target) {
            let short_code = '';
            if (target != '') {
                if (target.indexOf(",") != -1) {
                    var valArray = target.split(',');
                    $.each(valArray, function(i) {
                        var valArraytags = valArray[i].split('|');
                        short_code = short_code + valArraytags[0] + "|";
                    });
                } else {
                    if (target.indexOf("|") != -1) {
                        var valArray = target.split('|');
                        if (valArray[0] != '') short_code = valArray[0];
                    }
                }
            }
            if (short_code.indexOf("|") != -1) short_code = short_code.slice(0, -1);
            return short_code;
        }

        app.get_uri_data = function() {
            if (window.location.hash) {
                let hash = window.location.hash.replace('#', '');
                let parts = hash.split("&");
                let detail = app.get_option_value(parts[0]);
                let age = app.get_option_value(parts[1]);
                let gender = app.get_option_value(parts[2]);
                let client = app.get_option_value(parts[3]);
                let feeding = app.get_option_value(parts[4]);
                let skin_type = app.get_option_value(parts[5]);
                let skin_concern = app.get_option_value(parts[6]);
                let skin_enemy = app.get_option_value(parts[7]);
                let eye_concern = app.get_option_value(parts[8]);
                let lip_concern = app.get_option_value(parts[9]);
                let result = app.get_option_value(parts[10]);


                return {
                    detail: detail,
                    age: age,
                    gender: gender,
                    client: client,
                    feeding: feeding,
                    'skin-type': skin_type,
                    'skin-concern': skin_concern,
                    'skin-enemy': skin_enemy,
                    'eye-concern': eye_concern,
                    'lip-concern': lip_concern,
                    result: result
                };
            } else {
                return false;
            }
        };
        app.get_option_value = function(target) {
            if (target != '') {
                return target;
            }
            return "zz";
        };
        /* Extra */
        // ------------------------------------------------------------------
        app.selected_dress_opt = function(type, id) {
            $("ul." + type + " .option-button").removeClass("selected");
            $("ul." + type + " .option-button").each(function(index, value) {
                var slected_id = $(this).data("id");
                if (slected_id == id) {
                    $(this).addClass("selected");
                }
            });
        }
        app.validateEmail = function($email) {
            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            if (!emailReg.test($email)) {
                console.log("Please enter valid email id");
            } else {
                console.log("correct");
            }
        }
        app.rountine_finder_store_array = function() {
            var steps = [];
            //value = "local storage key";
            steps['detail'] = "finder_name";
            steps['age'] = "finder_age";
            steps['gender'] = "finder_gender";
            steps['client'] = "finder_client";
            steps['feeding'] = "finder_feeding";
            steps['skin-type'] = "finder_skin_type";
            steps['skin-concern'] = "finder_skin_concern";
            steps['skin-enemy'] = "finder_skin_enemy";
            steps['eye-concern'] = "finder_eye_concern";
            steps['lip-concern'] = "finder_lip_concern";
            steps['result'] = "finder_result";
            return steps;
        }
    }

});



$(document).ready(function(){

      resetAddtocartStorage();
      $(document).on("click",".addToCartItem",function(){
          showLoaderModel();
          resetAddtocartStorage();
          var variant_id = $(this).attr("data-id");
          if(variant_id){
            action_update_cart(1,variant_id,variant_id);
            var variant_title = decodeURI($(this).attr("data-title"));
            finder_event_track('Finder Results Page Add To Cart', variant_title);
          }
      });

      $(document).on("click",".close-cart-modal",function(){
            closeCartMessageModal();
      });     
      // Select Product Variant option
      $(document).on("click",".rfa-product-variants .rfaItemVid", function(ev){
          $(this).parents('.rfa-product-variants').find(".rfaItemVid").removeClass("active");
          $(this).addClass("active");
          $(this).parents('.rfa-product-variants').parents('.finder-product-info').find(".select-rfa-product").attr("data-v-id",$(this).attr("data-v-id"));
          $(this).parents('.rfa-product-variants').parents('.finder-product-info').find(".addToCartItem").attr("data-id",$(this).attr("data-v-id"));
      });

      // Add to cart Shop optimal routine products
      $(document).on("click",".rfa-sorp-addtocart-button", function(ev){
        resetAddtocartStorage();
        var totalCount = $(".finder-result-list-panel ul.product-list li.product-item input[name='personalisedProduct']:checked").length;
        if(totalCount > 0){
          showLoaderModel();
          var $yourset = $(".finder-result-list-panel ul.product-list li.product-item input[name='personalisedProduct']:checked");
          $yourset.each(function() {
              var product_id = $(this).attr("data-v-id");
              var last_var_id = '';
              var $this = $(this);
              if($this[0] === $yourset.last()[0]) {
                  last_var_id = product_id;
              }
              action_update_cart(1,product_id,last_var_id);
                var variant_title = decodeURI($(this).attr("data-title"));
            	finder_event_track('Finder Results Page Add To Cart', variant_title);
          });
        }
      });

      // Update Shop optimal routine selected products count
      $(document).on("click",".finder-result-list-panel ul.product-list input[name='personalisedProduct']", function(ev){
            update_rfa_sorp_count();
      });

      // Add to cart shop must-have only products
      $(document).on("click",".rfa-smhop-addtocart-button", function(ev){
        resetAddtocartStorage();
        var totalCount = $("ul.product-list li.product-item input[name='personalisedProduct']:checked.select-rfa-ymh-product").length;
        if(totalCount > 0){
          showLoaderModel();
          var $yourset = $("ul.product-list li.product-item input[name='personalisedProduct']:checked.select-rfa-ymh-product");
          $yourset.each(function() {
              var product_id = $(this).attr("data-v-id");
              var last_var_id = '';
              var $this = $(this);
              if($this[0] === $yourset.last()[0]) {
                  last_var_id = product_id;
              }
              action_update_cart(1,product_id,last_var_id);
          });
        }
      });
      
       // Update shop must-have only selected products count
      $(document).on("click","ul.product-list input[name='personalisedProduct'].select-rfa-ymh-product", function(ev){
            update_rfa_smhop_count();
      });

      // ============= YOUR OPTIMAL ROUTINE PRODUCTS =================
      var storageOptions = rfa_storage_options_array();
      var rfa_html = '';
      for( var key in storageOptions ) {
        if(storageOptions[key]){
          var storageOption = storageOptions[key];
          var results = get_rfa_product_by_handle(rfaKeyMasterJson[storageOption]);  
          if(results){
            $.each(results,function(i,v){
              rfa_html += htmlRFAResultProducts(v,key);
            });
            $(".finder-result-list-panel ul.product-list").html(rfa_html);
            update_rfa_sorp_count();
            update_rfa_smh_only_button();
            update_rfa_finder_name();
            update_rfa_tips();
          }
        }
      }
      // ============= YOUR OPTIMAL ROUTINE PRODUCTS =================

      // ============= DR LENS’ RECOMMENDED ADDITIONS PRODUCTS =================
        if ($(".js-finder-result").length > 0) {
          if(rfaRecProJson){
            var recpro_html = '';
            $.each(rfaRecProJson,function(i,v){
              var labelkey = i;
              if(labelkey != 'recommended_teashot'){
                var results = '';
                results = get_rfa_product_by_handle(v);
                if(results){
                  $.each(results,function(i1,v1){
                    recpro_html += htmlRFAResultProducts(v1,'Finishing Touch');
                  });
                }
              }else{
                var store = get_store_country();
                if(localStorage.getItem(store+'finder_skin_concern') && localStorage.getItem(store+'finder_skin_concern') != undefined){
                  var res_sc_arr = JSON.parse(localStorage.getItem(store+'finder_skin_concern')).split("|");
                  var res_sc = res_sc_arr[0];
                  if(rfaRecConJson['rfa_'+res_sc] != "true"){
                      var results = '';
                      results = get_rfa_product_by_handle(v);
                      if(results){
                        $.each(results,function(i1,v1){
                          recpro_html += htmlRFAResultProducts(v1,'Finishing Touch');
                        });
                      }
                  }
                }
              }
            });

            if(recpro_html){
              $(".recomended-panel").show();
              $(".recomended-panel ul.product-list").html(recpro_html);
              update_rfa_smhop_count();
              update_rfa_smh_only_button();
            }else{
              $(".recomended-panel").hide();
            }
          }
        }
      // ============= DR LENS’ RECOMMENDED ADDITIONS PRODUCTS =================
});

function htmlRFAResultProducts(v,key){
  var rfa_html = '';
  
  var title_subtitle = v.name.split(" - ");

  if(v.name){
    rfa_html += '<li class="product-item" data-key="'+key+'" data-tips="'+v.tips+'">';
    rfa_html += '<h3>'+key.replace("_", " ")+'</h3>';
    rfa_html += '<div class="finder-pic">';
    rfa_html += '<a href="/products/'+v.handle+'"><img src="'+v.image+'" alt=""></a>';
    
    if(v.tags.indexOf('rfa_sticker') != -1){
      rfa_html += '<div class="offer-title">';
      rfa_html += '<span>Your <br/>must–have</span>';
      rfa_html += '</div>';
    }
    
    rfa_html += '</div>';
    rfa_html += '<div class="finder-product-info">';
    rfa_html += '<div class="product-name-price">';

    if(title_subtitle[0]){
      rfa_html += '<h5>'+title_subtitle[0]+'</h5>';
    }else{
      rfa_html += '<h5>'+v.name+'</h5>';
    }

    if(v.variants){
        rfa_html += '<div class="product-price">'+v.variants[0].price+'</div>';
    }else{
        rfa_html += '<div class="product-price">'+v.price+'</div>';
    }


    rfa_html += '</div>';
    
    if(title_subtitle[1]){
      rfa_html += '<div class="small-text">'+title_subtitle[1]+'</div>';
    }else{
      rfa_html += '<div class="small-text">'+v.vendor+'</div>';  
    }
    
    if(v.variants[0].name != 'Default Title'){
      rfa_html += '<div class="size size-select-color rfa-product-variants">';
      $.each(v.variants,function(i1,v1){
        if(v1.name != 'Default Title'){
          if(i1 == 0){
            rfa_html += '<span><strong>'+v.optionsname+':</strong><ul class="options-list select-color"><li class="selectedli"><a href="javascript:;" class="rfaItemVid active">'+v1.name+'</a></li>';
            var activeOptCls = 'active';
            var activeOptClsSelect = 'liselected';
          }else{
            var activeOptCls = '';
            var activeOptClsSelect = '';
          }
          rfa_html += '<li class="options-li '+activeOptClsSelect+'"><a href="javascript:;" data-v-id="'+v1.id+'" data-v-price="'+v1.price+'" data-v-variant="'+v1.name+'" class="rfaItemVid '+activeOptCls+'">'+v1.name+'</a></li>';
        }
      });
      rfa_html += '<span class="select-icon"></span></ul></span></div>';
    }

    
    rfa_html += '<div class="product-description">'+v.description+'</div>';
    
    rfa_html += '<div class="rfa_quick_btnpanel">';
    if(v.available == "true"){
      rfa_html += '<div class="product-action"><a href="javascript:;" class="addToCartItem" data-id="'+v.variants[0].id+'">Quick Buy</a></div>';
    }else{
      rfa_html += '<div class="product-action"><span>OUT OF STOCK</span></div>';
    }
    
    rfa_html += '<div class="option-routine">';
    rfa_html += '<ul>';
    rfa_html += '<li>';
    rfa_html += '<div class="check-radio-option">';
    if(v.available == "true"){
        if(v.tags.indexOf('rfa_sticker') != -1){
            rfa_html += '<input type="checkbox" name="personalisedProduct" class="select-rfa-product select-rfa-ymh-product" data-v-id="'+v.variants[0].id+'" checked>';
        }else{
            rfa_html += '<input type="checkbox" name="personalisedProduct" class="select-rfa-product" data-v-id="'+v.variants[0].id+'" checked>';
        }
    }else{
      rfa_html += '<input type="checkbox" name="personalisedProduct" class="select-rfa-product" data-v-id="'+v.variants[0].id+'" data-title="'+ encodeURI(v.name) +'" disabled>';
    }  
    rfa_html += '<label>Include in Optimal Routine</label>';
    rfa_html += '</div>';
    rfa_html += '</li>';
    rfa_html += '</ul>';
    rfa_html += '</div>';
    rfa_html += '</div>';
    rfa_html += '</div>';
    rfa_html += '</li>';
  }
  console.log(rfa_html);
  console.log("I am herrrrr");
  return rfa_html;
}

function update_rfa_tips(){
  var html = '';
  $(".finder-result-list-panel ul.product-list li.product-item").each(function() {
      if($(this).attr("data-tips")){
          html += '<div class="tips-col2"><div class="dots"><span></span></div>';
          html += '<p>';
          html += $(this).attr("data-tips");
          html += '</p></div>';
      }
  });
  $(".rfa_tips").html(html);
}

function update_rfa_finder_name(){
    var store = get_store_country();
    if(localStorage.getItem(store+'finder_name') && localStorage.getItem(store+'finder_name') != undefined){
      $(".rfa_finder_name").html(JSON.parse(localStorage.getItem(store+'finder_name')));
    }
}

function update_rfa_sorp_count(){
    var totalCount = $(".finder-result-list-panel ul.product-list input[name='personalisedProduct']:checked").length;
    $(".rfa-sorp-count").html(totalCount+' products selected');
    update_rfa_smhop_count();
}

function update_rfa_smhop_count(){
    var totalCount = $("ul.product-list input[name='personalisedProduct']:checked.select-rfa-ymh-product").length;
    $(".rfa-smhop-count").html(totalCount+' products selected');
}

function update_rfa_smh_only_button(){
    var totalCount = $("ul.product-list input[name='personalisedProduct'].select-rfa-ymh-product").length;
    if(totalCount >= 1){
        $('.rfa-smhop-addtocart-button').show();
        $('.rfa-smhop-count').show();
    }else{
        $('.rfa-smhop-addtocart-button').hide();
        $('.rfa-smhop-count').hide();
    }
}

function get_rfa_product_by_handle(filterHandle){
  var results = [];
  $.each(rfaProductsJson,function(i,v){
      if(v.handle == filterHandle){
        results.push(rfaProductsJson[i]);  
      }
  });
  return results;
}

function rfa_storage_options_array() {
    var tags = [];
    var store = get_store_country();

    if(localStorage.getItem(store+'finder_skin_type') && localStorage.getItem(store+'finder_skin_type') != undefined){
      var res_str_b7 = JSON.parse(localStorage.getItem(store+'finder_skin_type'));
      var res_arr_b7 = res_str_b7.split("|");
      var res_tag_pm = res_arr_b7[1].split("#");
      tags['cleanser'] = res_tag_pm[2]; 
    }

    if(localStorage.getItem(store+'finder_skin_concern') && localStorage.getItem(store+'finder_skin_concern') != undefined){
      var res_str_b2 = JSON.parse(localStorage.getItem(store+'finder_skin_concern'));
      var res_arr_b2 = res_str_b2.split("|");
      var res_arr_a = res_arr_b2[1].split("#");
        tags['exfoliate'] = res_arr_a[0]; 
    }

    if(localStorage.getItem(store+'finder_skin_concern') && localStorage.getItem(store+'finder_skin_concern') != undefined){
      var res_str_b2 = JSON.parse(localStorage.getItem(store+'finder_skin_concern'));
      var res_arr_b2 = res_str_b2.split("|");
      var res_arr_a = res_arr_b2[1].split("#");
        tags['treat'] = res_arr_a[3]; 
    }
	
  	if(localStorage.getItem(store+'finder_skin_enemy') && localStorage.getItem(store+'finder_skin_enemy') != undefined){
      var res_str_b3 = JSON.parse(localStorage.getItem(store+'finder_skin_enemy'));
      var res_arr_b3 = res_str_b3.split("|");
        tags['mist'] = res_arr_b3[1];  
    }
  
    if(localStorage.getItem(store+'finder_skin_concern') && localStorage.getItem(store+'finder_skin_concern') != undefined){
      var res_str_b2 = JSON.parse(localStorage.getItem(store+'finder_skin_concern'));
      var res_arr_b2 = res_str_b2.split("|");
      var res_arr_c = res_arr_b2[1].split("#");
        tags['boost'] = res_arr_c[2];  
    }

    if(localStorage.getItem(store+'finder_skin_concern') && localStorage.getItem(store+'finder_skin_concern') != undefined){
      var res_str_b2 = JSON.parse(localStorage.getItem(store+'finder_skin_concern'));
      var res_arr_b2 = res_str_b2.split("|");
      var res_arr_serum = res_arr_b2[1].split("#");
        tags['serum'] = res_arr_serum[1];  
    }

    // if(localStorage.getItem(store+'finder_skin_concern') && localStorage.getItem(store+'finder_skin_concern') != undefined){
    //   var res_str_b2 = JSON.parse(localStorage.getItem(store+'finder_skin_concern'));
    //   var res_arr_b2 = res_str_b2.split("|");
    //   var res_arr_serum = res_arr_b2[1].split("#");
    //     tags['serum_pm'] = res_arr_serum[1];  
    // }

    if(localStorage.getItem(store+'finder_eye_concern') && localStorage.getItem(store+'finder_eye_concern') != undefined){
      var res_str_b6 = JSON.parse(localStorage.getItem(store+'finder_eye_concern'));
      var res_arr_b6 = res_str_b6.split("|");
      var res_arr_eyekey = res_arr_b6[1].split(",");  
      tags['eye'] = res_arr_eyekey[0];
    }
    
    if(localStorage.getItem(store+'finder_skin_type') && localStorage.getItem(store+'finder_skin_type') != undefined){
      var res_str_b1 = JSON.parse(localStorage.getItem(store+'finder_skin_type'));
      var res_arr_b1 = res_str_b1.split("|");
      var res_tag_am = res_arr_b1[1].split("#");
      tags['am_moisturise'] = res_tag_am[0];  
    }

    if(localStorage.getItem(store+'finder_skin_type') && localStorage.getItem(store+'finder_skin_type') != undefined){
      var res_str_b7 = JSON.parse(localStorage.getItem(store+'finder_skin_type'));
      var res_arr_b7 = res_str_b7.split("|");
      var res_tag_pm = res_arr_b7[1].split("#");
      tags['pm_moisturise'] = res_tag_pm[1]; 
    }

    if(localStorage.getItem(store+'finder_lip_concern') && localStorage.getItem(store+'finder_lip_concern') != undefined){
      var res_str_b8 = JSON.parse(localStorage.getItem(store+'finder_lip_concern'));
      var res_arr_b8 = res_str_b8.split("|");
      var res_arr_lipkey = res_arr_b8[1].split(","); 
      tags['lips'] = res_arr_lipkey[0];  
    }
    return tags;
}
// ====== Zelen Routine Finder APP ===================

// ===== Comman functiona for both APP ========
function resetAddtocartStorage(){
  var store = get_store_country();

  if(localStorage.getItem(store+'zelens_addtocart_success')){
      localStorage.removeItem(store+'zelens_addtocart_success');  
  }
  
  if(localStorage.getItem(store+'zelens_addtocart_error')){
    localStorage.removeItem(store+'zelens_addtocart_error');  
  }
}

function action_update_cart(qty,var_id,last_var_id=''){
    if(var_id){
      var store = get_store_country();
      CartJS.addItem(var_id, qty, {},{
          "success": function(data, textStatus, jqxhr) {
              if(localStorage.getItem(store+'zelens_addtocart_success')){
                localStorage.setItem(store+'zelens_addtocart_success', parseInt(localStorage.getItem(store+'zelens_addtocart_success'))+parseInt(1));
              }else{
                localStorage.setItem(store+'zelens_addtocart_success', parseInt(1));
              }
              if(var_id == last_var_id){
                showCartMessageModal();
              }
          },
          "error": function(jqxhr, textStatus, errorThrown) {
              if (jqxhr.responseJSON && jqxhr.responseJSON.status == 422) {
                    var errmsg = jqxhr.responseJSON.description;
              }
              
              if(errmsg && errmsg != undefined){
                  var storeErr = localStorage.getItem(store+'zelens_addtocart_error');

                  if(storeErr){
                      localStorage.setItem(store+'zelens_addtocart_error', storeErr+' | '+errmsg);
                  }else{
                      localStorage.setItem(store+'zelens_addtocart_error', errmsg);  
                  }
              }

              if(var_id == last_var_id){
                showCartMessageModal();
              }
          }
      });
    }
}

function showLoaderModel(){
  $(".modal-add-cart").fadeIn(800);
  $(".modal-cart-info").hide();
  $(".modal-loader").show();
}

function hideLoaderModel(){
  $(".modal-loader").hide();
  $(".modal-cart-info").show();
}

function showCartMessageModal(action,errmsg=''){
    hideLoaderModel();
    var store = get_store_country();

    var addedScount = localStorage.getItem(store+'zelens_addtocart_success');

    if(addedScount == 1){
      $(".modal-cart-info .rfa_success").html('<h4>Product Added to Bag</h4>').show();
    }else if(addedScount > 1){
      $(".modal-cart-info .rfa_success").html('<h4>'+addedScount+' Products Added to Bag</h4>').show();
    }else{
      $(".modal-cart-info .rfa_success").hide();  
    }

    var getErrorsStr = localStorage.getItem(store+'zelens_addtocart_error');
    if(getErrorsStr){
        html = '';
        var getErrorArr = getErrorsStr.split("|");
        if(getErrorArr){
          $.each(getErrorArr,function(i,v){
            html += '<p>'+v+'</p>';
          });
          $(".modal-cart-info .rfa_error").html(html).show();
        }else{
          $(".modal-cart-info .rfa_error").hide();
        }
    }

    //resetAddtocartStorage();
    setTimeout(function(){
        closeCartMessageModal();
    }, 20000);
}

function closeCartMessageModal(){
    $(".modal-cart-info .rfa_success").html('').hide();
    $(".modal-cart-info .rfa_error").html('').hide();
    $(".modal-add-cart").hide();
    $(".modal-cart-info").hide();
    $(".modal-loader").hide();
}
function get_store_country(){
    var host = window.location.host;
    var store = 'uk_';
    if (host.indexOf("eu") != -1) var store = 'eu_';
    else if (host.indexOf("us") != -1) var store = 'us_';
    return store;
}

$(document).on('cart.requestComplete', function(event, cart) {
    $("span.Header__CartCount").html(cart.item_count);
});


/*colour dropdown*/

$(document).on("click",".select-color", function(ev){
  var is_open = $(this).hasClass("open");
  if (is_open) {
    $(this).removeClass("open");
  } else {
    $(this).addClass("open");
  }
});

$(document).on("click",".select-color .options-li", function(ev){
    $(this).parents(".product-item").find('.select-color .options-li').removeClass("liselected");
    $(this).addClass("liselected");
 // var selected_value = $(this).parents(".product-item").find($(this)).html();
 // console.log(selected_value)
  // var selected_value = $(this).html();
  //  var first_li = $(".select-color li:first-child").html();
  //  $(".select-color li:first-child").html(selected_value);
  //  $(this).html(first_li);
});

$(document).mouseup(function(event) {
  var target = event.target;
  var select = $(".select-color");
  if (!select.is(target) && select.has(target).length === 0) {
    select.removeClass("open");
  }
});

// change price

$(document).on("click", ".options-li a", function(){
    $(this).parents(".product-item").find('.product-price').text($(this).data('v-price'));
    $(this).parents(".product-item").find('.selectedli a').text($(this).data('v-variant'));
    //alert($(this).data('v-variant'));
});

// ===== Comman functiona for both APP ========
